export const UPDATE_HOME_PAGE = 'callDirectory/UPDATE_HOME_PAGE';
export const UPDATE_REFERRAL_DATA = 'callDirectory/UPDATE_REFERRAL_DATA';
export const UPDATE_ALL_USERS_LISTING =
  'callDirectory/UPDATE_ALL_USERS_LISTING';
export const UPDATE_SOCIETY_DATA = 'callDirectory/UPDATE_SOCIETY_DATA';
export const UPDATE_USER_CAR_STATUS = 'callDirectory/UPDATE_USER_CAR_STATUS';
export const UPDATE_CLIENT_CARS_DATA = 'callDirectory/UPDATE_CLIENT_CARS_DATA';
export const UPDATE_BROWSING_MODE = 'callDirectory/UPDATE_BROWSING_MODE';
export const RESET_DATA = 'callDirectory/RESET_DATA';
export const UPDATE_SEARCH_DATA = 'callDirectory/UPDATE_SEARCH_DATA';
export const RESET_CLIENT_DATA = 'callDirectory/RESET_CLIENT_DATA';
export const UPDATE_CURRENT_DEALER = 'callDirectory/UPDATE_CURRENT_DEALER';
export const UPDATE_RESTRICT_DATA = 'callDirectory/UPDATE_RESTRICT_DATA';
export const UPDATE_ACTIVITY_TIME_RANGE =
  'callDirectory/UPDATE_ACTIVITY_TIME_RANGE';
